'use client';

import { useTranslations } from 'next-intl';
import { useEffect } from 'react';

import { ButtonLink } from '@commons/components/Button';
import Text from '@commons/components/Text';
import ResponsiveContainer from '@commons/containers/ResponsiveContainer';

// Type definition for the ErrorPage component props.

type Props = {
  error: Error & { digest?: string };
  reset: () => void;
};

/**
 * ErrorPage component.
 *
 * Must be a client component as it requires side effects.
 *
 * @see https://nextjs.org/docs/app/building-your-application/routing/error-handling#how-errorjs-works
 */

const ErrorPage = ({ error }: Props) => {
  const t = useTranslations('pages.error');

  // Log the error to an error reporting service.
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <ResponsiveContainer as="main">
      <Text as="h1" level="h2" transform="uppercase">
        {t('title')}
      </Text>
      <Text>{t('description.unavailable')}</Text>
      <Text marginBottom="md">{t('description.resolve')}</Text>
      <ButtonLink variant="primary" href="/">
        {t('button')}
      </ButtonLink>
    </ResponsiveContainer>
  );
};

export default ErrorPage;
